import styled from 'styled-components';

import { GridItem } from '@xing-com/grid';
import { SkeletonHeadline } from '@xing-com/skeleton';
import { spaceXXL, spaceXS } from '@xing-com/tokens';

const StyledGridItem = styled(GridItem)`
  margin-bottom: ${spaceXXL};
`;

const StyledSkeletonHeadline = styled(SkeletonHeadline)`
  margin-bottom: ${spaceXS};
`;

export const Styled = {
  GridItem: StyledGridItem,
  SkeletonHeadline: StyledSkeletonHeadline,
};
